import React from 'react';
import { 
  CheckCircleIcon, 
  XCircleIcon,
  ExclamationTriangleIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';

export default function ExchangeConnections({ connections, onRefresh }) {
  // Helper function to get icon based on status
  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" />;
      case 'disconnected':
        return <XCircleIcon className="h-5 w-5 text-red-500" />;
      case 'limited':
        return <ExclamationTriangleIcon className="h-5 w-5 text-yellow-500" />;
      default:
        return null;
    }
  };

  // Helper function to get status text with appropriate color
  const getStatusText = (status) => {
    switch (status) {
      case 'connected':
        return <span className="text-green-600">Connected</span>;
      case 'disconnected':
        return <span className="text-red-600">Disconnected</span>;
      case 'limited':
        return <span className="text-yellow-600">Limited Access</span>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-white shadow-sm rounded-lg border border-gray-100">
      <div className="px-4 py-5 sm:px-6 flex justify-between items-center">
        <div>
          <h3 className="text-lg font-medium leading-6 text-gray-900">Exchange API Status</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Current connection status for all trading exchanges
          </p>
        </div>
        <button 
          onClick={onRefresh} 
          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md flex items-center"
        >
          <ArrowPathIcon className="h-4 w-4 mr-2" />
          Refresh
        </button>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          {connections.map((connection, index) => (
            <div key={index} className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 flex items-center">
                {connection.logo && (
                  <img 
                    src={connection.logo} 
                    alt={`${connection.name} logo`} 
                    className="h-5 w-5 mr-2"
                  />
                )}
                {connection.name}
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-1 sm:mt-0 flex items-center">
                {getStatusIcon(connection.status)}
                <span className="ml-2">{getStatusText(connection.status)}</span>
              </dd>
              <dd className="mt-1 text-sm text-gray-500 sm:col-span-1 sm:mt-0">
                {connection.lastChecked ? `Last checked: ${connection.lastChecked}` : ''}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
